import { ApolloClient, InMemoryCache, from, createHttpLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { toast } from "react-toastify";

import AppData from "@app@::@data";

const httpLink = createHttpLink({
    uri: `${AppData.project.backendDomain}/g`,
    credentials: "include",
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
    const statusCode = (networkError as any)?.statusCode || (networkError as any)?.response?.status;
    const hasGraphqlRateLimitError = !!graphQLErrors?.some((error) => /too many|rate limit/i.test(error.message));

    if ((statusCode === 429 || hasGraphqlRateLimitError) && !toast.isActive("rate-limit-notification")) {
        const retryAfter = (networkError as any)?.response?.headers?.get?.("retry-after");
        const retryMessage = retryAfter ? ` Please retry in ${retryAfter}s.` : " Please retry shortly.";
        toast(`You're being rate limited.${retryMessage}`, { type: "warning", autoClose: 5000, toastId: "rate-limit-notification" });
    }
});

const client = new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache({
        addTypename: false,
        dataIdFromObject: (o) => (o._id ? `${o.__typename}:${o._id}` : ""),
    }),
});

export default client;
